// const SUBSCRIPTION_API = '/sitecore/api/ssc/isagenix/subscriptionapi/1';
const SUBSCRIPTION_SESSION_READ_API = '/sitecore/api/ssc/ro/isagenix/subscriptionapi';

export async function cancelSubscription(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json',
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        type: 'DELETE',
        url: `${SUBSCRIPTION_SESSION_READ_API}/CancelAutoship`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export async function updateFrequency(frequency) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json',
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        type: 'POST',
        url: `${SUBSCRIPTION_SESSION_READ_API}/updateautoshipfrequency`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify({
            frequency
        })
    });
}

export async function updateNextOrderDate(nextAutoshipDate) {
    // nextAutoshipDate should be in toISOString() format
    return $.ajax({
        headers: {
            'Content-Type': 'application/json',
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        type: 'POST',
        url: `${SUBSCRIPTION_SESSION_READ_API}/updatenextautoship`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify({
            nextAutoshipDate
        })
    });
}

export async function updateNextAutoshipAndFrequency(payload) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json',
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        type: 'POST',
        url: `${SUBSCRIPTION_SESSION_READ_API}/UpdateNextAutoshipAndFrequency`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(payload)
    });
}
